export default __webpack_public_path__ + "static/iPad-mini-1cbc59f6099e9d19e201403604e84694.webp";